module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"es":{"filters":"Filtros","allOrders":"Todas las órdenes","fiveLastDays":"Últimos cinco días","today":"Hoy"},"en":{"filters":"Filters","allOrders":"All orders","fiveLastDays":"Last five days","today":"Today"}}')
  delete Component.options._Ctor
}
